"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InboundError = void 0;
var InboundError;
(function (InboundError) {
    InboundError["UNDEFINED_PARAMETER"] = "UNDEFINED_PARAMETER";
    InboundError["CDSKU_NOT_FOUND"] = "CDSKU_NOT_FOUND";
    InboundError["CDSKU_TRANSFER_CONFLICT"] = "CDSKU_TRANSFER_CONFLICT";
    InboundError["CROSS_DOCK_STATUS_MISMATCH"] = "CROSS_DOCK_STATUS_MISMATCH";
    InboundError["TOO_CLOSE_TO_CUTOFF_TO_ADD_PACKAGE"] = "TOO_CLOSE_TO_CUTOFF_TO_ADD_PACKAGE";
    InboundError["PALLET_SCANNED_AT_SOURCE_HUB"] = "PALLET_SCANNED_AT_SOURCE_HUB";
    InboundError["LABEL_ID_NOT_FOUND"] = "LABEL_ID_NOT_FOUND";
    InboundError["FBW_ERR_EXTERNAL_ID"] = "FBW_ERR_EXTERNAL_ID";
    InboundError["FBW_ERR_ASN"] = "FBW_ERR_ASN";
    InboundError["FBW_ERR_ASN_ZERO"] = "FBW_ERR_ASN_ZERO";
    InboundError["FBW_ERR_ASN_MANY"] = "FBW_ERR_ASN_MANY";
    InboundError["FBW_ERR_DSKU"] = "FBW_ERR_DSKU";
    InboundError["FBW_ERR_WAREHOUSE"] = "FBW_ERR_WAREHOUSE";
    InboundError["INVALID_WAREHOUSE"] = "INVALID_WAREHOUSE";
    InboundError["INVALID_PALLET_SCAN"] = "INVALID_PALLET_SCAN";
    InboundError["INVALID_CDSKU_SCAN"] = "INVALID_CDSKU_SCAN";
    InboundError["CDSKU_NOT_ON_TRANSFER"] = "CDSKU_NOT_ON_TRANSFER";
    InboundError["DESTINATIONS_DO_NOT_MATCH"] = "DESTINATIONS_DO_NOT_MATCH";
    InboundError["INVALID_TRACKING_CODE"] = "INVALID_TRACKING_CODE";
    InboundError["TRACKING_CODE_IN_USE"] = "TRACKING_CODE_IN_USE";
    InboundError["CROSS_DOCK_ASN_NOT_FOUND"] = "CROSS_DOCK_ASN_NOT_FOUND";
    InboundError["PROBLEM_PACKAGE_NOT_FOUND"] = "PROBLEM_PACKAGE_NOT_FOUND";
    InboundError["CANNOT_CREATE_SIBLING_PROBLEM_PACKAGE"] = "CANNOT_CREATE_SIBLING_PROBLEM_PACKAGE";
    InboundError["BARCODE_NOT_FOUND"] = "BARCODE_NOT_FOUND";
    InboundError["OUT_OF_BOUNDS"] = "OUT_OF_BOUNDS";
    InboundError["FAILED_TO_GENERATE_ASN_FOR_REROUTED_PALLET"] = "FAILED_TO_GENERATE_ASN_FOR_REROUTED_PALLET";
    InboundError["PALLET_DESTINATION_WAREHOUSE_MISMATCH"] = "PALLET_DESTINATION_WAREHOUSE_MISMATCH";
    InboundError["MILK_RUN_DESTINATION_WAREHOUSE_MISMATCH"] = "MILK_RUN_DESTINATION_WAREHOUSE_MISMATCH";
    InboundError["ADD_CDSKU_CLOSED_PALLET"] = "ADD_CDSKU_CLOSED_PALLET";
    InboundError["REMOVE_CDSKU_CLOSED_PALLET"] = "REMOVE_CDSKU_CLOSED_PALLET";
    InboundError["CROSS_DOCKS_DO_NOT_MATCH"] = "CROSS_DOCKS_DO_NOT_MATCH";
    InboundError["PALLET_ALREADY_IN_STATUS"] = "PALLET_ALREADY_IN_STATUS";
    InboundError["CANNOT_REOPEN_PALLET"] = "CANNOT_REOPEN_PALLET";
    InboundError["UNROUTEABLE_PALLET"] = "UNROUTEABLE_PALLET";
    InboundError["ARRIVED_AT_INCAPABLE_FC"] = "ARRIVED_AT_INCAPABLE_FC";
    InboundError["PACKAGE_NEED_MEASUREMENT"] = "PACKAGE_NEED_MEASUREMENT";
    InboundError["PACKAGE_NEEDS_AUDIT"] = "PACKAGE_NEEDS_AUDIT";
    InboundError["PALLET_NO_DESTINATION"] = "PALLET_NO_DESTINATION";
})(InboundError = exports.InboundError || (exports.InboundError = {}));
//# sourceMappingURL=InboundError.js.map